module.exports = __webpack_public_path__ + "static/media/print.957a8f90.svg";